export default __webpack_public_path__ + "static/media/three.f23da11d.png";